import React, { Component } from 'react';
import ItemEvento from './ItemEvento';
import './Evento.css';
import { Config } from './Config.js';
import $ from 'jquery'

var cores = ['#ffffff', '#fafafa', '#f6f6f6', '#eeeeee']

class EventoEncerrado extends Component {

    constructor(props) {
        super(props)
        this.state = {
            eventos: [],
            mostrarTudo: false
        }

        this.filtrarEventos = this.filtrarEventos.bind(this);                
    }

    componentDidMount() {
        var url = this.props.fase ? `${Config.eventoURL}/tipo${Config.basename}fase/${this.props.fase}` : `${Config.eventoURL}/tipo${Config.basename}`;

        $.ajax({
            url: url,
            dataType: 'json',
            cache: false,
            success: (result) => {

                this.setState({
                    eventos: result
                });
            }
        });      
    }

    renderItemEvento(eventoNome, eventoVagas, EventoSalario, EventoURL, i) {
        return <ItemEvento key={i} EventoNome={eventoNome} EventoVagas={eventoVagas} EventoSalarioMaximo={EventoSalario} EventoURL={EventoURL} />;
    }

    renderEventoItems(eventos, letraInicial) {

        eventos = letraInicial && letraInicial != 'Todos' ? eventos.filter(c => { return c.eventoNomeAbreviado.substring(0, 1) == letraInicial }) : eventos;

        return eventos.map((x, i) => { return this.renderItemEvento(x.eventoNomeAbreviado, x.eventoTotalVagas, x.strEventoSalarioMaximo, `/${x.eventoURL}`, i) });
    }    

    filtrarEventos(inicial, e) {        
        
        this.setState({ LetraInicial: inicial });        
        this.render();

    }

    RenderFiltrosEncerrados(letra) {
       
        var arrayIniciaisEventos = ['Todos'];

            if (this.state.eventos) {

                this.state.eventos.map(c => {

                    c.eventos.map(e => {

                        var inicial = e.eventoNomeAbreviado.substring(0, 1);                        

                        if (arrayIniciaisEventos.indexOf(inicial) < 0)
                            arrayIniciaisEventos.push(inicial);
                    });

                });
            }

            return <center>
                <div className="q_circle_text_holder">
                    {this.RenderLetrasEventosEncerrados(arrayIniciaisEventos,letra)}
                </div>
            </center>;
       
    }

    RenderLetrasEventosEncerrados(arrayIniciaisEventos,letra) {

        var styleNormal = { marginLeft: '5px', marginTop: '2px' };
        var styleSelecionado = { marginLeft: '5px', marginTop: '2px', backgroundColor: '#0C4A87' };       

        return arrayIniciaisEventos.map(a => {
            var styleUtilizado = styleNormal;
            if (a == letra)
                styleUtilizado = styleSelecionado;
            else if (!this.state.LetraInicial && a == 'Todos')
                styleUtilizado = styleSelecionado;

            return (<a key={a} data-itemprop="url" className="icon_with_title_link" href="#" onClick={(e) => { e.preventDefault(); this.filtrarEventos(a, e) }} target="_self" style={styleUtilizado}>{a}</a>)
        });
    }

    RenderEventosAgrupadosPorFase() {

        var letra = this.state.LetraInicial;
        console.log(letra);
        var eventosParaMostrar = this.state.eventos;
        
        return eventosParaMostrar.map((x, i) => {
            return (

                <div key={i} className="full_width_inner">
                    <div className="vc_row wpb_row section vc_row-fluid  grid_section bg-white" style={{ backgroundColor: x.faseEvento != 'Encerrados' ? cores[i] : '#ffffff', borderTop: '1px solid rgb(238, 238, 238)', paddingTop: '87px', paddingBottom: '80px', textAlign: 'left' }}>
                        <div className=" section_inner clearfix">
                            <div className="section_inner_margin clearfix">
                                <div className="wpb_column vc_column_container vc_col-sm-12">
                                    <div className="vc_column-inner">
                                        <div className="wpb_wrapper" style={{ marginBottom: 0 }}>
                                            <div className="wpb_text_column wpb_content_element ">
                                                <div className="wpb_wrapper">
                                                    <h2 className="text-center">{x.faseEvento}</h2>
                                                </div>                                               
                                            </div>
                                            <div className="separator small center"></div>
                                            <div className="separator transparent center"></div>
                                            <div className="itens-container">
                                                {this.RenderFiltrosEncerrados(letra)}
                                                <div class="separator transparent center"></div>
                                                <ul className="q_circles_holder five_columns no_line">
                                                    {this.renderEventoItems(x.eventos, letra)}
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )
        });
    }

    render() {
        return (
            <div>
                <div className="title_outer animate_title_area with_image" data-height="500" style={{ opacity: '0', height: '100px' }}></div>
                <div className="full_width" style={{ paddingTop: '85px' }}>                   
                    {this.RenderEventosAgrupadosPorFase()}                    
                </div>
            </div >
        );
    }
}

export default EventoEncerrado;
